export const environment = {
  // googleConfig: {
  //   clientId: '1077057199438-8defg7srgkv6dsa5jg0lmhvfqkdapj6s.apps.googleusercontent.com',
  //   dummyClientSecret: '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',
  // },
    googleConfig: {
    clientId: '1084468442363-h7dmbvanb62mf00an8qgp5uj2d9tt5e5.apps.googleusercontent.com',
    dummyClientSecret: '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',
  },
  // baseUrl: 'http://192.168.0.178:8080/api/v1/signature',
  baseUrl: 'https://esig-qa.amrize.com',
  amrizeStripeEnglish: "https://storage.googleapis.com/esign-dev-bkt/branding/Amrize%20Stripe%20.png",
  amrizeStripeFrench: "https://storage.googleapis.com/esign-dev-bkt/branding/Amrize%20Stripe%20FR%20Preview(1400%20X%2065).png",
  amrizeStripeEnglishBE:"https://storage.googleapis.com/esign-dev-bkt/branding/Amrize_Stripe_new.png",
  amrizeStripeFrenchBE:"https://storage.googleapis.com/esign-dev-bkt/branding/Amrize%20Stripe%20FR%20Set%20(%20600%20X%2065).png"
};